/**
 * vue-actionbox
 * @version 1.1.0
 * @author Jaroslav Slaby <jaroslav.slaby@avast.com>
 * @requires avast.web.campaignMarkerCookie
 * @requires avast.web.downloadPopup
 */

(function() {
	'use strict';
	Vue.config.devtools = true;

	Vue.config.errorHandler = function(err, vm, info) {
		// err: error trace
		// vm: component in which error occured
		// info: Vue specific error information such as lifecycle hooks, events etc.
		console.log('errorHandler');
		console.log(1, err);
		console.log(2, vm);
		console.log(3, info);
		// TODO: Perform any custom logic or log to server
	};

	var detectedOS = avastGlobals.detect.os.name.toLowerCase(),
		vueActionBoxRow = document.querySelectorAll('.js-action-box-row'),
		campaignMarkerModule = avm.require('avast.web.campaignMarkerCookie')(),
		downloadPopup = avm.require('avast.web.downloadPopup');

	var STATICPATH = document.querySelector('link[href*=".css"]').getAttribute('href').split('/c/')[0];

	// Return if no Action boxes present on page
	// @todo : this can be defined in avast.js config where modules boot
	if (vueActionBoxRow.length === 0) {
		return false;
	}

	// components

	// price box / multibox
	Vue.component('price-box', {
		template: '#price-box',
		delimiters: ['<%', '%>'],
		props: ['settings', 'config'],
		data: function() {
			return {
				selectedIndex: this.settings.default_option || 1,
				togglerIndex: this.settings.default_option ? this.settings.default_option - 1 : 0,
				boxCount: this.settings.options.option_1.pricelist !== undefined ? 'boxCount-' + Object.keys(this.settings.options.option_1.pricelist).length : 'boxCount-1',
				theme: this.settings.theme || 'light'
			};
		},
		methods: {
			changeIndex: function(value) {
				this.selectedIndex = value + 1;
				this.togglerIndex = value;
				this.$emit('change_slots', value);
			},
			updateLinks: function(html) {
				return html.replace(/'i\//gm, '\'' + STATICPATH + '/i/');
			}
		},
		computed: {
			isToggler: function() {
				return this.settings.hide_toggler !== 'true';
			}
		}
	});

	// toggler
	Vue.component('toggler', {
		template: '#toggler',
		delimiters: ['<%', '%>'],
		props: ['display', 'settings', 'hide', 'selectedoption'],
		methods: {
			handleClick: function(event, indexValue) {
				this.$emit('change_data', indexValue);
			}
		},
		computed: {
			horizontalToggler: function() {
				return this.display === 'true';
			},
			showToggler: function() {
				if ('hide_toggler' in this.settings && this.settings.hide_toggler === 'true') {
					return false;
				} else if (this.settings.toggler_placeholder === 'true') {
					return false;
				} else {
					return true;
				}
			},
			isDisabled: function() {
				return Object.keys(this.settings.options).length === 1;
			}
		}
	});

	// box - pricebox content with price
	Vue.component('box', {
		template: '#box',
		delimiters: ['<%', '%>'],
		props: ['slotsconfig', 'settings', 'box', 'contentindex', 'hidetitles', 'saveText', 'firstYearText', 'customClasses', 'currentText', 'originalText', 'textSubscription', 'legalGBText', 'buttonDefaultText'],
		data: function() {
			return {
				legalNote: '<span class="subscription-link" data-toggle="modal" data-target="subscription-modal" tabindex="0" role="button"><span class="sub-text">' + this.textSubscription + '</span>&nbsp;<span class="sub-icon"></span></span>',
				legalNoteGBStart: '<span class="subscription-link" data-toggle="modal" data-target="subscription-modal-gb" tabindex="0" role="button"><span class="sub-text">',
				legalNoteGBEnd: '</span>&nbsp;<span class="sub-icon"></span></span>'
			};
		},
		methods: {
			showContent: function(key) {
				return key in this.settings && this.settings[key][this.contentindex] !== 'undefined';
			},
			setCampaignMarker: function() {
				var cartLinks = this.$el.querySelectorAll('[data-role="cart-link"]');

				// Update campaign marker data and href attributes with __trSrc cookie
				if (cartLinks.length) {
					campaignMarkerModule.setCampaignMarkerCookie(cartLinks);
				}

				if (avastGlobals.web.abtest !== undefined) {
					cartLinks.forEach(function(el) {
						var dataCM = el.getAttribute('data-campaign-marker').split('~'),
							hrefCM = el.getAttribute('href').split('~'),
							abTest = avastGlobals.web.abtest.ticketNumber,
							testVariant = avastGlobals.web.abtest.testVariant;

						dataCM[3] = abTest;
						dataCM[4] = testVariant;
						hrefCM[3] = abTest;
						hrefCM[4] = testVariant;
						el.setAttribute('data-campaign-marker', dataCM.join('~'));
						el.setAttribute('href', hrefCM.join('~'));
					});
				};
				return cartLinks;
			}
		},
		computed: {
			showPlatforms: function() {
				return 'platforms' in this.settings && this.settings.platforms.length > 0;
			},
			showLabel: function() {
				if ('label_texts' in this.settings && 'box' + (this.contentindex + 1) in this.settings.label_texts) {
					return true;
				} else {
					if ('discountPercent' in this.box && this.box.discountPercent !== '') {
						return true;
					}
					return false;
				}
			},
			labelText: function() {
				if ('label_texts' in this.settings && 'box' + (this.contentindex + 1) in this.settings.label_texts) {
					return this.settings.label_texts['box' + (this.contentindex + 1)].replace('&nbsp;', ' ');
				} else {
					if ('discountPercent' in this.box && this.box.discountPercent !== '') {
						return this.saveText.replace('$$', this.box.discountPercentFormatted).replace('&nbsp;', ' ');
					}
					return '';
				}
			},
			instructionText: function() {
				if ('instructions' in this.settings && 'box' + (this.contentindex + 1) in this.settings.instructions) {
					return this.settings.instructions['box' + (this.contentindex + 1)].replace('&nbsp;', ' ');
				}
			},
			buttonVariant: function() {
				if ('buttonVariant' in this.settings && 'box' + (this.contentindex + 1) in this.settings.buttonVariant) {
					return this.settings.buttonVariant['box' + (this.contentindex + 1)];
				}
			},
			buttonText: function() {
				if ('cta_text' in this.settings && 'box' + (this.contentindex + 1) in this.settings.cta_text) {
					return this.settings.cta_text['box' + (this.contentindex + 1)];
				} else {
					return this.buttonDefaultText;
				}
			},
			showCTANote: function() {
				return true;
				/* if ('cta_note' in this.settings && this.settings.cta_note.length >= this.contentindex + 1 || avastGlobals.web.locale === 'en-gb') {
					return true;
				} else {
					if ('discountPercent' in this.box && this.box.discountPercent !== '') {
						return true;
					}
					return false;
				} */
			},
			CTANoteText: function() {
				var result = '';

				if ('cta_note' in this.settings && this.settings.cta_note.length >= this.contentindex + 1) {
					result = this.settings.cta_note[this.contentindex];
				} else if ('discountPercent' in this.box && this.box.discountPercent !== '' && isYearPeriod(this.box)) {
					result = this.firstYearText;
				}

				// set A11y screen reader text to cta_note with strikethrough price
				if (/<s>.+<\/s>/.test(result)) {
					result = result.replace(/<s>/, '<span class="sr-only">' + this.originalText + '</span><s>').replace(/<\/s>/, '</s> <span class="sr-only">' + this.currentText + '</span>');
				}

				// create subscription link or let original cta_note (for GB is specific subscription link)
				if (avastGlobals.web.locale === 'en-gb' && !('auto_cta_note' in this.settings && this.settings.auto_cta_note === 'false')) {
					var price = this.box.priceFormat.replace('#c', this.box.currencySymbol).replace('#p', this.box.priceRounded);

					return this.legalNoteGBStart + this.legalGBText.replace('$$', price) + this.legalNoteGBEnd;

				} else if (!('auto_cta_note' in this.settings && this.settings.auto_cta_note === 'false')) {
					if (result.length > 0) {
						var specialDotLocales = ['ja-jp', 'zh-cn', 'zh-tw'];
						
						if (specialDotLocales.indexOf(avastGlobals.web.locale) > -1) {
							var fixedDot = (result.slice(-1) !== '。') ? '。 ' : ' ';
						} else {
							var fixedDot = (result.slice(-1) !== '.') ? '. ' : ' ';
						}
						return result + fixedDot + this.legalNote;

					} else {
						return this.legalNote;
					}
				} else {
					return result;
				}
			},
			showPromotion: function() {
				return 'promo' in this.settings && 'box' + (this.contentindex + 1) in this.settings.promo;
			}
		},
		updated: function() {
			this.setCampaignMarker();
		},
		mounted: function() {
			this.$nextTick(function () {
				var cartLinks = this.$el.querySelectorAll('[data-role="cart-link"]');
				setTimeout(function () {
					if (cartLinks.length) {
						campaignMarkerModule.setCampaignMarkerCookie(cartLinks);
					}
				}, 0);
			})
			var button = this.$el.querySelector('a[data-role="download-link"]:not([data-behavior="downloadPage"])');
			
			// Subscription modal
			initModal(this.$el);
			/* if (avastGlobals.web.locale === 'en-us' || avastGlobals.web.locale === 'en-gb') {
				initModal(this.$el);
			} */

			if (button !== null) {
				downloadPopup.setPopup(button);
			}
		},
		watch: {
			settings: {
				handler: function(val) {
					this.$nextTick(function() {
						var button = this.$el.querySelector('a[data-role="download-link"]:not([data-behavior="downloadPage"])');

						// Subscription modal
						initModal(this.$el);
						/* if (avastGlobals.web.locale === 'en-us' || avastGlobals.web.locale === 'en-gb') {
							initModal(this.$el)
						} */

						if(button !== null) {
							downloadPopup.setPopup(button);
						}
					});
				}
			}
		}
	});

	// price wrapper
	Vue.component('price-wrapper', {
		template: '#price-wrapper',
		delimiters: ['<%', '%>'],
		props: ['price', 'period', 'showSrText', 'hideperiod', 'settings'],
		computed: {
			// position of currency symbol
			symbolShowPrefix: function() {
				return /^#c/.test(this.price.priceFormat);
			},
			symbol: function() {
				if (this.symbolShowPrefix) {
					return this.price.currencySymbol.replace('&nbsp;', '');
				} else {
					return '&nbsp;' + this.price.currencySymbol.replace('&nbsp;', '');
				}
			},
			decimal: function() {
				return this.price.decimalSeparator + this.price.realPriceDecimalPart;
			},
			showDecimal: function() {
				return this.price.realPriceDecimalPart !== '';
			}
		},
		methods: {
			updatePeriodForUk: function() {
				// update period text for UK compliance, disable automatic period text if "diable_auto_period" is true
				if (avastGlobals.web.locale == 'en-gb' && ('disable_auto_period' in this.settings === false || 'disable_auto_period' in this.settings && this.settings.disable_auto_period !== 'true')) {
					if (('priceFlag' in this.price === false || 'priceFlag' in this.price && this.price.priceFlag !== 'M') && this.price.maintenance !== '1' && this.period !== '/call') {
						if (this.price.maintenance === '36') {
							this.period = '/3 years';
						} else if (this.price.maintenance === '24') {
							this.period = '/2 years';
						} else {
							this.period = '/year';
						}
					}
				}
			}
		},
		updated: function() {
			this.updatePeriodForUk();
		},
		mounted: function() {
			this.updatePeriodForUk();
		}
	});

	// price before sale
	Vue.component('old-price', {
		template: '#old-price',
		delimiters: ['<%', '%>'],
		props: ['price', 'showDiscount'],
		computed: {
			showOldPrice: function() {
				return typeof this.price.discount !== 'undefined' && this.price.discount !== '0' && this.showDiscount !== 'false' && avastGlobals.web.locale !== 'en-gb';
			},
			showMonthPrice: function() {
				return 'realPriceRoundedPerMonth' in this.price && this.price.realPriceRoundedPerMonth !== undefined && avastGlobals.web.locale === 'en-gb' && this.price.maintenance !== "1";
			},
			priceText: function() {
				if ('realPriceRoundedPerMonth' in this.price && this.price.realPriceRoundedPerMonth !== undefined && avastGlobals.web.locale === 'en-gb' && this.price.maintenance !== "1") {
					return this.price.realPriceRoundedPerMonth;
				} else {
					var e = document.createElement('div');
					e.innerHTML = this.price.priceFormatted;
					return e.childNodes.length === 0 ? '' : e.childNodes[0].innerText;
				}

			}
		}
	});

	// box content
	Vue.component('box-content', {
		delimiters: ['<%', '%>'],
		props: [],
		template: '#box-content',
		data: function() {
			return {};
		}
	});

	// Init
	for (var i = 0; i < vueActionBoxRow.length; i++) {
		var element = vueActionBoxRow[i],
			rowSettings = JSON.parse(element.getAttribute('data-settings')),
			globalConfigArray = [],
			BoxesIndex = [],
			slotsConfig = new slotsConfigObj();

		// default slots config prototype
		function slotsConfigObj(header_titles, platforms, label_texts, cta_note, secondary_cta, footer_texts, show_listPrice, installments, instructions) {
			this.header_titles = header_titles || false;
			this.platforms = platforms || false;
			this.label_texts = label_texts || false;
			this.cta_note = cta_note || false;
			this.secondary_cta = secondary_cta || false;
			this.footer_texts = footer_texts || false;
			this.show_listPrice = show_listPrice || false;
			this.installments = installments || false;
			this.instructions = instructions || false;
		}

		// avoid JS error if rowSettings is null
		if (!rowSettings && rowSettings === null) {
			rowSettings = []
		}

		// creates array with slots configuration for all variants
		for (var j = 0; j < rowSettings.length; j++) {
			var config = rowSettings[j],
				priceboxArray = [];

			for (var l = 0; l < Object.keys(config.options).length; l++) {
				var key = Object.keys(config.options)[l],
					obj = config.options[key],
					options = new slotsConfigObj(),
					installments = false;

				for (var m = 0; m < Object.keys(options).length; m++) {
					var opt = Object.keys(options)[m];
					if (opt in obj) {
						options[opt] = true;
					};
				};

				if ('pricelist' in obj) {
					for (var n = 0; n < Object.keys(obj.pricelist).length; n++) {
						var pricelistCoupon = Object.keys(obj.pricelist)[n];
						if ('installments' in obj.pricelist[pricelistCoupon]) {
							installments = true;
						}

						// automatic sale label
						if (obj.pricelist[pricelistCoupon].discountPercent !== undefined && obj.pricelist[pricelistCoupon].discountPercent !== '0') {
							if (!options.label_texts) {
								options.label_texts = true;
							}
							if (isYearPeriod(obj.pricelist[pricelistCoupon])) {
								options.cta_note = true;
							}
						}

						// subscription detail for en-us region
						options.cta_note = true;
						/* if (avastGlobals.web.locale === 'en-us' || avastGlobals.web.locale === 'en-gb') {
							options.cta_note = true;
						} */

						// monthly price for en-gb local instead old price
						if (avastGlobals.web.locale === 'en-gb' && obj.pricelist[pricelistCoupon].realPriceRoundedPerMonth) {
							options.show_listPrice = true;
						}
					};
				}

				options.installments = installments;
				priceboxArray.push(options);
			};
			globalConfigArray.push(priceboxArray);
		};

		// globalConfigArray - object with slots configuration for each boxes variant in whole actionbox row

		// default slots configuration
		for (var index = 0; index < globalConfigArray.length; index++) {
			var config = globalConfigArray[index], // configuration for each pricebox in row
				usedIndex = 0; // if default option isn't set and platform detection isn't active, then first variant is used

			if (rowSettings[index].default_option !== undefined) {
				// default_option is defined

				usedIndex = rowSettings[index].default_option - 1;

			} else {
				if (rowSettings[index].platform_detect === 'true') {
				// default_option not defined but platform detection is active

					usedIndex = searchPlatform(rowSettings[index], detectedOS);

					if (usedIndex === false) {
					// check if the same platform was found in settings as detected user's platform
						usedIndex = searchPlatform(rowSettings[index], rowSettings[index].default_platform);

						if (usedIndex === false) {
							// default platform not found, is set first variant
							usedIndex = 0;
						}
					}

					rowSettings[index].default_option = usedIndex + 1; // todo - use diferent variable and add check in template
				};

			}

			for (var o = 0; o < Object.keys(slotsConfig).length; o++) {
				var conf = Object.keys(slotsConfig)[o];

				if (config[usedIndex][conf] === true) {
					slotsConfig[conf] = true;
				};
			}

			BoxesIndex.push(0);
		};

		element = new Vue({
			el: element,
			delimiters: ['<%', '%>'],
			data: function() {
				return {
					globalSettings: rowSettings,
					slotsConfigGlobal: globalConfigArray,
					slotsConfig: slotsConfig,
					boxesOptionsIndex: BoxesIndex
				};
			},
			computed: {
				priceBoxs: function() {
					return this.globalSettings.filter(function(box) {
						return box.type.toUpperCase() === 'PRICEBOX';
					});
				},
				eventData: function() {
					return new CustomEvent('actionbox-updated', {'detail': {'element':this.$el}});
				}
			},
			methods: {
				changeSlots: function(optionIndex, boxIndex) {
					var _this = this;

					this.$nextTick(function(){window.dispatchEvent(this.eventData)}) // send global event on toggler change

					this.boxesOptionsIndex[boxIndex] = optionIndex;
					this.slotsConfig = new slotsConfigObj();
					this.slotsConfig.installments = false;
					for (var index = 0; index < this.slotsConfigGlobal.length; index++) {
						var config = this.slotsConfigGlobal[index];
						for (var k = 0; k < Object.keys(_this.slotsConfig).length; k++) {
							var key = Object.keys(_this.slotsConfig)[k];

							if (config[_this.boxesOptionsIndex[index]][key]) {
								_this.slotsConfig[key] = true;
							}
						};
					};
				}
			},
			mounted: function() {
				this.$nextTick(function(){window.dispatchEvent(this.eventData)})
			}
		});

	};

	function searchPlatform(dataset, platform) {
		// search user platform in dataset
		var returnedValue = false;

		Object.keys(dataset.options).forEach(function(key, ind) {
			if ('platform' in dataset.options[key]) {
				if (platform.toUpperCase() === dataset.options[key].platform.toUpperCase()) {
					returnedValue = ind;
				}
			}
		});

		return returnedValue;
	}

	function isYearPeriod(obj) {
		if ('priceFlag' in obj && obj.priceFlag !== 'M') {
			return true;
		} else {
			return false;
		}

		/*
		var yearRegex = new RegExp('(year|vuosi|år|año|Jahr|an|anno|jaar|ano|χρόνο|ročně|rok|év|год|yıl|年|년|ปี|any|taon|tahun|năm|वर्ष|年|年|рік|سنة|שנה|سنويًا)$'),
			monthRegex = new RegExp('buwan|bulan');

		if ('period_text' in obj && yearRegex.test(obj.period_text) && !monthRegex.test(obj.period_text)) {
			return true;
		} else {
			return false;
		}
		*/
	}

	function initModal(element) {
		var modalButton = element.querySelector('[data-toggle="modal"]'),
			modalTarget = modalButton !== null ? modalButton.getAttribute('data-target') : null;

		if (modalButton !== null && modalTarget !== null) {
			modalButton.addEventListener('click', function() {
				loadModal(modalTarget);
			});

			modalButton.addEventListener('keypress', function(e) {
				if (e.charCode === 13) {
					loadModal(modalTarget);
				}
			});
		}
	}

	function loadModal(target) {
		// !!make sure name of source page for modal and target in modal trigger are same!!
		if (document.getElementById(target) === null) {
			var contentHolder = document.querySelector('.content-holder'),
				xhr = new XMLHttpRequest();

			xhr.onreadystatechange = function() {
				if (this.readyState == 4 && this.status == 200) {

					var container = document.createElement('div');

					container.innerHTML = this.responseText;
					contentHolder.append(container);

					var modal = new BSN.Modal(document.getElementById(target));
					modal.show();
				}
			};

			xhr.open('GET', 'https://' + avastGlobals.web.domain + avastGlobals.web.ulocale + '/' + target, true);
			xhr.setRequestHeader('x-requested-with', 'XMLHttpRequest');
			xhr.send(null);
		} else {
			var modal = new BSN.Modal(document.getElementById(target));
			modal.show();
		}
	}

})();
